export function formUtilValidateEmail(obj, event, email) {
  if (event.type === 'blur' || obj.isErrorDisplayed(email.error)) {
    const regex = /^(.+)@(.+)\.(.+)$/;

    if (regex.test(email.input.value)) {
      obj.hideError(email);
    } else {
      obj.showError(email);
    }
  }
}

export function formUtilIsErrorDisplayed(target: HTMLElement): boolean {
  return target.style.display === 'block';
}

export function formUtilHideError(obj, error, input, inputContainer): void {
  error.style.display = 'none';
  input.classList.remove(obj.cssClass.errorField);
  inputContainer.classList.remove(obj.cssClass.errorInputContainer);
}

export function formUtilTogglePasswordVisibility(event): void {
  const eyeIcon = event.target;

  // reveal/conceal password
  const passwordInput = eyeIcon.parentNode.previousElementSibling.children[0];

  const currentType = passwordInput.getAttribute('type');
  const newType = currentType === 'password' ? 'text' : 'password';

  passwordInput.setAttribute('type', newType);

  // switch icon
  const crossedIconClass = 'elc-eye-crossed-icon';
  const iconClass = 'elc-eye-icon';

  eyeIcon.classList.contains(crossedIconClass)
    ? (eyeIcon.classList.remove(crossedIconClass), eyeIcon.classList.add(iconClass))
    : (eyeIcon.classList.remove(iconClass), eyeIcon.classList.add(crossedIconClass));
}
